import {
    createStyles,
    makeStyles,
    TableCell,
    TableRow,
    Theme,
    withStyles,
} from '@material-ui/core';

export const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.common.white,
            },
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.secondary.light,
            },
        },
    }),
)(TableRow);

export const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.background.paper,
            textAlign: 'center',
        },
        body: {
            fontSize: 14,
            textAlign: 'center',
            minWidth: '7rem',
        },
    }),
)(TableCell);

export const bodyStyles = makeStyles((theme: Theme) =>
    createStyles({
        emptyCell: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            borderBottomColor: 'transparent',
            backgroundColor: theme.palette.background.paper,
        },
    }),
);
